import { isFromMarketingCampaign } from '@/views/config/coupon/helper/utils';

export const persistCartConstant = Object.defineProperties({}, {
  persistShoppingBagSwitch: {
    get() {
      // from backend feature toggle
      return window.$isEnabled('displayPersistentCart');
    }
  },
  enablePersistShoppingBag: {
    get() {
      // disabled persist shopping cart functionality
      if (!persistCartConstant.persistShoppingBagSwitch) {
        return false;
      }

      // from marketing link, should empty the shopping cart
      if (isFromMarketingCampaign()) {
        return false;
      }

      return true;
    }
  }
});

const continueShopping = () => {
  const referrer = document.referrer || '';
  if (referrer.includes?.('/pricing')) {
    return window.location.replace(referrer);
  }

  window.location.replace('/pricing');
};

const addShoppingBagPersistEventListener = () => {
  window.addEventListener('billingShoppingBagInstanceReady', () => {
    window.billingShoppingBagInstance?.updateOptions({
      clickShoppingBag: () => {
        if (window.$context?.is.checkoutPage) {
          window.$context?.$emit('plan-edit-action');
        }
      },
    });
  });
};

const removePersistShoppingBagWhenInVisible = () => {
  if (!persistCartConstant.enablePersistShoppingBag) {
    const element = document.querySelector('#new_buyflow_header_container .billing-shopping-bag__container');
    element && element.remove();
  }
};

const initShoppingBagAction = () => {
  removePersistShoppingBagWhenInVisible();
  addShoppingBagPersistEventListener();
};

export const getPersistShoppingBagLink = () => {
  try {
    const currentURL = new URL(window.location.href);
    // force replace current pathName to /opc/buy, avoid customer redirect to checkout page when the customer click the shopping cart
    currentURL.pathname = '/opc/buy';
    return currentURL.toString();
  } catch (e) {
    return window.location.href;
  }
};


export default {
  addShoppingBagPersistEventListener,
  continueShopping,
  removePersistShoppingBagWhenInVisible,
  initShoppingBagAction,
};
